import { render, staticRenderFns } from "./ContentClass.demo.vue?vue&type=template&id=03adbcf3&scoped=true&"
import script from "./ContentClass.demo.vue?vue&type=script&lang=js&"
export * from "./ContentClass.demo.vue?vue&type=script&lang=js&"
import style0 from "./ContentClass.demo.vue?vue&type=style&index=0&id=03adbcf3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03adbcf3",
  null
  
)

export default component.exports